"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalise = capitalise;
exports.compressPrice = compressPrice;
exports.excerptify = excerptify;
exports.toSlug = toSlug;
exports.trim = trim;
exports.unSlug = unSlug;
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
/**
 * Convert a string into a "slug" to be used in a URL.
 *
 * This mainly just lower cases and converts spaces to dashes, but it will also
 * strip out non-alphanumeric characters, convert forward slashes to dashes and
 * collapse multiple dashes into one.
 *
 * @param {String} string The string to slugify.
 *
 * @return {String} The slug.
 */
function toSlug(string) {
  return "".concat(string).replace(/[ /-]+/g, '-').replace(/(^[\s-]+|[\s-]+$)/g, '').toLowerCase().replace(/[^a-z0-9-]/g, '');
}

/**
 * Attempts to make a slug more user friendly; information is lost when slugifying
 * something, e.g. casing and potentially characters are lost, so this cannot
 * totally reverse things.
 *
 * @param {String}  string        The string to unslug.
 * @param {Boolean} options.recase Whether to attempt to convert back to mixed
 *                  case; not possible to do this completely reliably.
 *
 * @return {String} The unslugged string.
 */
function unSlug(string) {
  var {
    recase = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!string) {
    return string;
  }
  var temp = string.replace(/-/g, ' ');
  if (!recase) return temp;
  return temp.replace(/\b[a-z]/g, letter => letter.toUpperCase()).replace(/\bMc([a-z])/g, (_, letter) => "Mc".concat(letter.toUpperCase()));
}

/**
 * Trims trailing and leading whitespace from a string.
 * QUESTION: What does this function do that String.prototype.trim() does not?
 *
 * @param {String} s The string to trim.
 *
 * @return {String} A string without trailing or leading whitespace.
 */
function trim(s) {
  return s && s.replace(/(^\s+|\s+$)/g, '');
}

/**
 * Makes an excerpt of a string.
 *
 * Does not handle HTML content; strip content, including HTML entities,  before
 * excerpting.a string.
 *
 * By default it will break on words, leading to shorter strings than the length
 * requested; this can be overriden py passing the strict option.
 *
 * @param {String}  s              The string to excerpt.
 * @param {Number}  length         The length of the excerpt.
 * @param {Boolean} options.strict Whether to cut at exactly the given length.
 * @param {String}  options.suffix The suffix to append when the string is cut;
 *                  not used if the string is not cut.
 *
 * @return {String}
 */
function excerptify(s, length) {
  var _context;
  var {
    strict = false,
    suffix = '…'
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!length || length < 0 || length >= s.length) {
    return s;
  }
  var chopped = trim(s).substr(0, length + 1);
  var [, substring] = strict ? [] : chopped.match(/^(.+)[\s.;()\-!?,]+/) || [];
  var result = substring ? substring.replace(/[\s.;()\-!?,]+$/, '') : (0, _slice.default)(chopped).call(chopped, 0, -1);
  return (0, _concat.default)(_context = "".concat(result)).call(_context, suffix);
}
function capitaliseWord(word) {
  var {
    toLower = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return [word.charAt(0).toUpperCase(), (toLower ? word.toLowerCase() : word).substr(1)].join('');
}
function capitalise(string) {
  var {
    toLower = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return string.replace(/\w\S*/g, w => capitaliseWord(w, {
    toLower
  }));
}
var compress = function (number, divisor) {
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return (number / divisor).toFixed(precision).replace(/\.?0+$/, '');
};
function compressPrice(price) {
  var _context2, _context3, _context4;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$';
  switch (true) {
    case price >= 1000000:
      return (0, _concat.default)(_context2 = "".concat(prefix)).call(_context2, compress(price, 1000000, 2), "m");
    case price >= 1000:
      return (0, _concat.default)(_context3 = "".concat(prefix)).call(_context3, compress(price, 1000, 2), "k");
    default:
      return (0, _concat.default)(_context4 = "".concat(prefix)).call(_context4, price);
  }
}